module.exports = __webpack_public_path__ + "static/media/homo_sapiens.male.4626c730.svg";